export default "__VITE_ASSET__CJ2cASWW__"